import React from "react";
import { UiInputGroupWr } from "../../../../../_uiComponents/common/form/UiInputComponents";
import { Grid } from "@mui/material";
import { Form } from "react-final-form";
import UiInput from "../../../../_uiComponents/UiInput";
import RadioGroup from "@mui/material/RadioGroup";
import { UiRadioBtn } from "../../../../../_uiComponents/common/form/UiRadioBtn";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import UiSwitch from "../../../../_uiComponents/UiSwitch";
import UiMultipleSelect from "../../../../_uiComponents/UiMultipleSelect";
import {
     UiButton,
     UiBackButton,
} from "../../../../../_uiComponents/common/form/UiButton";
import UiDateRangePicker from "../../../../_uiComponents/UiDateRangePicker";
import HierarchyDataGrid from "../../../../_uiComponents/hierarchyDataGrid/HierarchyDataGrid";

export default function Campaign(props) {
     return (
          <>
               <UiInputGroupWr title="Campaign Details">
                    <Grid container spacing={2}>
                         <Grid
                              item
                              xs="12"
                              lg="12"
                              sx={{ pt: 2, pb: 2 }}
                         >
                              <Grid
                                   container
                                   spacing={2}
                                   sx={{ pb: 1 }}
                              >
                                   <Grid
                                        item
                                        xs="12"
                                        lg="12"
                                        sx={{
                                             textAlign:
                                                  "left",
                                        }}
                                   >
                                        <div className="sba-radio-label">
                                             Type
                                        </div>
                                        <FormControl>
                                             <div className="sba-radio">
                                                  <RadioGroup
                                                       row
                                                       aria-labelledby="demo-row-radio-buttons-group-label"
                                                       name="row-radio-buttons-group"
                                                  >
                                                       <UiRadioBtn
                                                            value="spin & win"
                                                            control={
                                                                 <Radio />
                                                            }
                                                            label="Spin & Win"
                                                       />
                                                       <UiRadioBtn
                                                            value="prize draw"
                                                            control={
                                                                 <Radio />
                                                            }
                                                            label="Prize Draw"
                                                       />
                                                       <UiRadioBtn
                                                            value="leagues"
                                                            control={
                                                                 <Radio />
                                                            }
                                                            label="Leagues"
                                                       />
                                                       <UiRadioBtn
                                                            value="banded"
                                                            control={
                                                                 <Radio />
                                                            }
                                                            label="Banded"
                                                       />
                                                       <UiRadioBtn
                                                            value="target"
                                                            control={
                                                                 <Radio />
                                                            }
                                                            label="Target & Win"
                                                       />
                                                  </RadioGroup>
                                             </div>
                                        </FormControl>
                                   </Grid>
                              </Grid>

                              <Grid container spacing={2}>
                                   <Grid
                                        item
                                        xs="12"
                                        lg="6"
                                   >
                                        <UiInput
                                             name="12"
                                             type="text"
                                             label="Name"
                                        />
                                   </Grid>
                              </Grid>
                              <Grid container spacing={2}>
                                   <Grid
                                        item
                                        xs="12"
                                        lg="6"
                                   >
                                        <div className="sba-date-range-picker">
                                             <UiDateRangePicker name="12" />
                                        </div>
                                   </Grid>
                              </Grid>
                              <Grid container spacing={2}>
                                   <Grid item xs={4}>
                                        <FormControlLabel
                                             control={
                                                  <UiSwitch name="12" />
                                             }
                                             label="Active"
                                             labelPlacement="top"
                                             sx={{
                                                  mt: 2,
                                                  ml: 0,
                                             }}
                                        />
                                   </Grid>
                              </Grid>
                         </Grid>
                    </Grid>
               </UiInputGroupWr>

               <UiInputGroupWr title="Data Source">
                    <Grid
                         container
                         spacing={2}
                         sx={{ mb: 1 }}
                    >
                         <Grid item xs="12" lg="6">
                              <UiMultipleSelect
                                   label="Participant Data"
                                   multiplePrint
                              />
                         </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                         <Grid item xs="12" lg="6">
                              <UiMultipleSelect
                                   label="Sales Data"
                                   multiplePrint
                              />
                         </Grid>
                    </Grid>
               </UiInputGroupWr>
               <UiInputGroupWr title="Campaign Template">
                    <Grid
                         container
                         spacing={2}
                         sx={{ mb: 1 }}
                    >
                         <Grid item xs="12" lg="6">
                              <UiMultipleSelect
                                   label="Template"
                                   multiplePrint
                              />
                         </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                         <Grid item xs="12" lg="6">
                              <UiMultipleSelect
                                   label="Products"
                                   multiplePrint
                              />
                         </Grid>
                    </Grid>
               </UiInputGroupWr>
               <UiInputGroupWr title="Participants">
                    <Grid container spacing={2}>
                         <Grid item xs="12" lg="12">
                              <FormControl>
                                   <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                   >
                                        <UiRadioBtn
                                             value="Hierarchy"
                                             control={
                                                  <Radio />
                                             }
                                             label="Hierarchy"
                                        />
                                        <UiRadioBtn
                                             value="Job Role"
                                             control={
                                                  <Radio />
                                             }
                                             label="Job Role"
                                        />
                                        <UiRadioBtn
                                             value="Location"
                                             control={
                                                  <Radio />
                                             }
                                             label="Location"
                                        />
                                   </RadioGroup>
                              </FormControl>
                         </Grid>
                         <Grid item xs="12" lg="12">
                              <HierarchyDataGrid />
                         </Grid>
                    </Grid>
               </UiInputGroupWr>

               <div className="sba-campaign-content-button">
                    <UiButton
                         name="Clear"
                         variant="outlined"
                         size="large"
                    />
                    <UiButton
                         name="Save"
                         variant="contained"
                         size="large"
                    />
               </div>
          </>



     );
}
